export default class DateParse {
  public static ParseTimeFromUTC(dateField): string | undefined {
    if (dateField?.includes('T')) {
      dateField = dateField.split('T')[0]
      return dateField
    }
    else{
      return ''
    }
  }
}
